import { render, staticRenderFns } from "./BillingNewPaymentPlaceholder.vue?vue&type=template&id=c79ed680&scoped=true&"
import script from "./BillingNewPaymentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./BillingNewPaymentPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79ed680",
  null
  
)

export default component.exports